module.exports = function(h, row) {
    if (row.price) {
        return 'RM' + row.price;
    } else {
        return '';
    }
};



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/inventory/coupon/price.jsx